import React from 'react';
import { classNames } from '../tools/helpers';
import toHref from '../tools/fetcher';

export default function Logo({ children, className }) {
    const pathImg = (imgName) =>
        toHref(
            `/wp-content/plugins/react-plugin/react-app/build/assets/${imgName}.svg`,
        )

    return (
        <div className="flex gap-x-2">
            <img
                src={pathImg('logo32')}
                alt="KarirEmas.id Logo"
                width={32}
            />
            <p
                className={classNames(
                    '!m-0 font-bold leading-8 text-[24px]',
                    className,
                )}
            >
                Karir
                <span className={'font-normal'}>Emas</span>
                {children}
            </p>
        </div>
    );
}
